import { PageHeader } from "./layoutChrome";
import { VISOR_MODULE_BREADCRUMB_ROOT } from "@/modules/workModuleCore";
import VisoresSatHubBody from "./VisoresSatHubBody";

export default function VisoresSatHub() {
  return (
    <>
      <PageHeader
        title="Visores CFDI (Similar SAT)"
        subtitle="Tres secciones: Visor SAT CFDI Emitidos, Recibidos y Nominas. Abra solo la que necesite."
        breadcrumb={[VISOR_MODULE_BREADCRUMB_ROOT, "Visores CFDI (Similar SAT)"]}
      />
      <VisoresSatHubBody wrapperClassName="p-8 max-w-7xl mx-auto space-y-4" />
    </>
  );
}
